import { render, staticRenderFns } from "./FileUploadComponent.vue?vue&type=template&id=81b60c50&"
import script from "./FileUploadComponent.vue?vue&type=script&lang=ts&"
export * from "./FileUploadComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81b60c50')) {
      api.createRecord('81b60c50', component.options)
    } else {
      api.reload('81b60c50', component.options)
    }
    module.hot.accept("./FileUploadComponent.vue?vue&type=template&id=81b60c50&", function () {
      api.rerender('81b60c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Elements/FileUploadComponent.vue"
export default component.exports